import { z } from "zod";
import { otpValidator } from "../../../lib/validator/otp";

export const OtpFormSchema = z.object({
  code: otpValidator,
});

export type OtpFormSchemaType = z.infer<typeof OtpFormSchema>;
